import React from 'react';
import { i18n } from '@lt/localization';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';

import type { IFilter } from '../types';

const FilterOperators = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <MultichoiceFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    Filter={FilterOperators}
    expandLabel={i18n.t('filters.operators.show')}
    visibleItems={3}
  />
);

export default Object.assign(FilterOperators, {
  filterName: 'operators',
  filterLabel: i18n.t('filters.operators.title'),
});
